module.exports = __webpack_public_path__ + "img/move.57fe74c8.svg";